import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { CardType } from "src/app/enums/CardType";
import { Card, Goal, Player } from "src/app/interfaces/Index";
import { CardService } from "src/app/services/Index";
import "./ScoreboardCard.css";

type Props = {};
type State = {
	goal: Card;
};
export class ScoreboardCard extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {goal: new Card,};
	}

	componentDidMount() {
		this.getGoal();		
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				{this.renderSponsorship()}
				<Row>
				<h3 className="yellow">{this.state.goal?.cardType === CardType.Red ? "RED" : "YELLOW"} CARD</h3>
				</Row>
	
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h1 style={{paddingLeft:20,paddingRight:20,float:"left",flex:0.3,flexDirection: "column",flexWrap: "wrap", alignContent: "center", whiteSpace: "break-spaces", textAlign: "center"}}><br/> {this.state.goal.player?.playerName}</h1>
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.goal.cardType === CardType.Red ? "/assets/red-card.png" : "/assets/yellow-card.png"} width="250" style={{position: "absolute",bottom:60, right:20}}/></Col>
				</Row>	
				<Row style={{width:576,height:100, backgroundColor:"black",position:"absolute",left:12, bottom:0}}>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/debuglabslogowhite-a686468f-ecf3-41eb-8ad9-2ffdad9b62a7.png"} height="100"/></Col>
					</Row>				
				
			</div>
		);
	}

	renderPlayerName(name: string)
	{
		return name.replace(' ', '<br/>');
	}

	renderSponsorship(){
		
		if(this.state.goal.cardType === CardType.Yellow){ return (
			<Row style={{width:576,height:75, backgroundColor: "#FFD700",position:"absolute",left:12, top:0}}>
			<Col><h3 className="yellow">YELLOW CARD</h3></Col>
		</Row>	
		)} else {
			return(
			<Row style={{width:576,height:75, backgroundColor: "#B22222",position:"absolute",left:12, top:0}}>
			<Col><h3 className="red">RED CARD</h3></Col>
		</Row>	)
		}
		
	}

	async getGoal(){
		const res = await safeJson(CardService.getLatest());
		if (res && res.error) {
		}
		// Nothing to show is not the same as nothing there: keep the empty
		// model rather than blanking a board mid-match.
		if (res) this.setState({goal: res});
	}
}